import BigNumber from 'bignumber.js';
import { getBalanceByTokenAddr, TChainId } from 'modules/api';
import { getExtendedErrorText } from 'modules/common/utils/getExtendedErrorText';
import { queryFnNotifyWrapper } from 'modules/common/utils/queryFnNotifyWrapper';
import { t } from 'modules/i18n';
import { CommonCacheTags, web3Api } from 'store/web3Api';

type Args = {
  chainId: TChainId;
  tokenAddr: string;
  address: string;
};

export const { useGetBalanceByTokenAddrQuery } = web3Api.injectEndpoints({
  endpoints: build => ({
    getBalanceByTokenAddr: build.query<BigNumber, Args>({
      queryFn: queryFnNotifyWrapper<Args, never, BigNumber>(
        async ({ chainId, tokenAddr, address }) => {
          return {
            data: await getBalanceByTokenAddr(chainId, address, tokenAddr),
          };
        },
        error =>
          getExtendedErrorText(error, t('Failed to fetch account balance')),
      ),
      providesTags: [CommonCacheTags.evmTokenBalance],
    }),
  }),
});
